module.exports = __webpack_public_path__ + "static/perlin_noise-8043bfc41c422ed1a252c55108690b0e.png";